import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';
import SoundAssetKeys from '../SoundAssetKeys';
import ShapeTextButton from '../ui/ShapeTextButton';

export default class PrintScreenMenu extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     */
    constructor(scene)
    {
        super(scene);

        let backTxt = ABCyaPhaser.Text.addText(0, 0, 24, 0x3258A7, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString("creation.back"), this, false).setOrigin(0);

        let btnNames = [
          {name:"HEADING", label:ABCyaPhaser.Localization.instance.getLocalizedString("letter.heading")}, 
          {name:"SALUTATION", label:ABCyaPhaser.Localization.instance.getLocalizedString("letter.salutation")}, 
          {name:"BODY", label:ABCyaPhaser.Localization.instance.getLocalizedString("letter.body")}, 
          {name:"CLOSING", label:ABCyaPhaser.Localization.instance.getLocalizedString("letter.closing")}, 
          {name:"SIGNATURE", label:ABCyaPhaser.Localization.instance.getLocalizedString("letter.signature")}, 
          {name:"SAVE", label:ABCyaPhaser.Localization.instance.getLocalizedString("creation.save")}, 
          {name:"PRINT", label:ABCyaPhaser.Localization.instance.getLocalizedString("creation.print")}
      ];

        this.totalBtnWidth = 0;
        this.btns = this.createAllBts(btnNames, []);

        let spacing = (this.scene.scale.width - (this.totalBtnWidth + backTxt.width)) / 7;
        backTxt.x = spacing;
        for (let i = 0; i < this.btns.length; i++)
        {
            let b = this.btns[i];
            if (i == this.btns.length - 1)
            {
                //place save button above
                if (this.btns.length == 6)
                {
                    b.x = (this.scene.scale.width / 2) - (b.getBounds().width / 2);
                    b.y = -(b.getBounds().height + 50);
                }
                else
                {
                    b.y = -(b.getBounds().height + 50);
                    b.x = this.btns[i - 2].x + (this.btns[i - 2].getBounds().width - b.getBounds().width);
                    //move last btn
                    this.btns[i - 1].x = b.x + (b.getBounds().width - this.btns[i - 1].getBounds().width);
                    this.btns[i - 1].y = -((b.getBounds().height + 50) * 2);
                }

            }
            else
            {
                b.x = (i == 0) ? backTxt.x + backTxt.width + spacing : this.btns[i - 1].x + this.btns[i - 1].getBounds().width + spacing;
            }

            this.add(b);
            b.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.handleMenuBtn(b));
        }
    }

    createAllBts(arr, finalArr)
    {
        finalArr = finalArr || [];
        let btnTxt = arr[0].name;

        const c = (btnTxt == "Back:" || btnTxt == "SAVE" || btnTxt == "PRINT") ? 0xF4805C : 0xFFFFFF;
        const f = (btnTxt == "Back:" || btnTxt == "SAVE" || btnTxt == "PRINT") ? FontKeys._asapbold : FontKeys._cardenio_modernregular;
        const txtc = (btnTxt == "Back:" || btnTxt == "SAVE" || btnTxt == "PRINT") ? 0xFBE796 : 0xF7911D;
        const txtSize = (btnTxt == "SAVE" || btnTxt == "PRINT") ? 36 : 32;

        const  btn = new ShapeTextButton(this.scene, arr[0].label, c, f, txtSize, txtc);
        btn.name = btnTxt;
        if (btnTxt != "SAVE" && btnTxt != "PRINT") this.totalBtnWidth += btn.getBounds().width;
        
        finalArr.push(btn);

        let remainingArr = arr.slice(1);

        if (remainingArr.length == 0)
        {
            return finalArr;
        }
        else
        {
            return this.createAllBts(remainingArr, finalArr);
        }
    }

    handleMenuBtn(sender)
    {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._clickSound, this.scene);
        this.emit("BTN_SELECT", { menuItemName: sender.name, menuIndex: this.btns.indexOf(sender) });
    }
}